import { graphql, useStaticQuery } from 'gatsby';
import { ContentfulText } from './ContentfulText';

function RemoteText({ name, preserveWhitespace, className, children }) {
    const data = useStaticQuery(graphql`
        {
            allContentfulTextBlocks {
                edges {
                    node {
                        id
                        name
                        textRich {
                            raw
                        }
                        textPlain {
                            textPlain
                        }
                        markDownText {
                            childMarkdownRemark {
                                html
                                htmlAst
                            }
                        }
                    }
                }
            }
        }
    `);

    const text = data.allContentfulTextBlocks.edges.find((n) => n.node.name === name);
    if (!text) {
        return <span>Text not found - {name}</span>;
    }

    return (
        <ContentfulText
            textPlain={text?.node?.textPlain?.textPlain}
            textRichRaw={text?.node?.textRich?.raw}
            textHtml={text?.node?.markDownText?.childMarkdownRemark?.html}
            preserveWhitespace={preserveWhitespace}
            className={className}
        >
            {children}
        </ContentfulText>
    );
}

export default RemoteText;
